import type { BattleState } from "./types";

const UINT32_RANGE = 4_294_967_296;

export function normalizeSeed(seed: number): number {
  const normalized = seed >>> 0;
  return normalized === 0 ? 0x6d2b79f5 : normalized;
}

export function nextRandom(state: BattleState): number {
  let value = state.randomState >>> 0;
  value ^= value << 13;
  value ^= value >>> 17;
  value ^= value << 5;
  state.randomState = value >>> 0;
  return state.randomState / UINT32_RANGE;
}

export function randomBetween(
  state: BattleState,
  minimum: number,
  maximum: number,
): number {
  return minimum + nextRandom(state) * (maximum - minimum);
}

